import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { BaseUITextStyles, BodyText, Heading } from '../typography';
import OutsideClickHandler from 'react-outside-click-handler';

const Container = styled.div`
  display: flex;
  max-width: 480px;
  box-sizing: border-box;
  padding: ${theme.spacings[5].rem};
  background-color: ${theme.colors.primary.white};
  box-shadow: 0px 4px 4px ${theme.colors.neutrals.transparentGrays[6]};
`;

const ContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[3].rem};
`;

const LeftContent = styled.div`
  ${ContentStyles}
  flex-grow: 1;
  border-right: 1px solid ${theme.colors.neutrals.transparentGrays[5]};
`;

const Title = styled(Heading).attrs({ size: 6 })`
  color: ${theme.colors.primary.graysRed};
`;

const Body = styled(BodyText).attrs({ size: 'sm' })`
  max-width: 209px;
`;

const RightContent = styled.div`
  ${ContentStyles}
  min-width: 114px;
  text-align: right;
`;

const Link = styled.a.attrs({ size: 'sm' })`
  ${BaseUITextStyles}
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

export type BurgerMenuLink = {
  href: string;
  text: string;
  trackingID: string;
};

export type BurgerMenuProps = {
  links: BurgerMenuLink[];
  className?: string;
  onClick?: (trackingID: string) => void;
  onClose: (e?: MouseEvent) => void;
};

export const BurgerMenu: React.FC<BurgerMenuProps> = ({
  links,
  className,
  onClick,
  onClose,
}) => {
  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <Container className={className}>
        <LeftContent>
          <Title>Not sure on what to do next?</Title>
          <Body size="sm">
            Contact our support centre to speak to our expert team on how you
            can make the most out of your Grays account.
          </Body>
        </LeftContent>
        <RightContent>
          {links.map((link) => (
            <Link
              href={link.href}
              onClick={() => onClick && onClick(link.trackingID)}
            >
              {link.text}
            </Link>
          ))}
        </RightContent>
      </Container>
    </OutsideClickHandler>
  );
};
